<template>
  <el-card shadow="always" class="col-md-8 offset-2 mt-3">
    <el-form :model="form" label-width="200px">
      <el-form-item label="Часовой пояс">
        <el-select v-model="form.timezone" placeholder="Выберите часовой пояс" filterable>
          <el-option
            v-for="tz in timezones"
            :key="tz"
            :label="timezoneLabels[tz] || tz"
            :value="tz"
          />
        </el-select>
      </el-form-item>
      <el-form-item style="display:none;" label="Интервал между записями">
        <el-select v-model="form.cellInterval" placeholder="Например, 15 минут">
          <el-option :label="'5 минут'" :value="5" />
          <el-option :label="'10 минут'" :value="10" />
          <el-option :label="'15 минут'" :value="15" />
          <el-option :label="'20 минут'" :value="20" />
          <el-option :label="'30 минут'" :value="30" />
          <el-option :label="'60 минут'" :value="60" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="saveTimezone">Сохранить</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'SettingsProfile',
  data() {
    const timezoneLabels = {
      'Europe/Kaliningrad': 'Калининград (GMT+2)',
      'Europe/Moscow': 'Москва (GMT+3)',
      'Europe/Samara': 'Самара (GMT+4)',
      'Asia/Yekaterinburg': 'Екатеринбург (GMT+5)',
      'Asia/Omsk': 'Омск (GMT+6)',
      'Asia/Novosibirsk': 'Новосибирск (GMT+7)',
      'Asia/Krasnoyarsk': 'Красноярск (GMT+7)',
      'Asia/Irkutsk': 'Иркутск (GMT+8)',
      'Asia/Yakutsk': 'Якутск (GMT+9)',
      'Asia/Vladivostok': 'Владивосток (GMT+10)',
      'Asia/Sakhalin': 'Сахалин (GMT+11)',
      'Asia/Magadan': 'Магадан (GMT+11)',
      'Asia/Kamchatka': 'Камчатка (GMT+12)',
      'Asia/Almaty': 'Алматы (GMT+6)',
      'Asia/Aqtobe': 'Актобе (GMT+5)',
      'Asia/Baku': 'Баку (GMT+4)',
      'Asia/Tbilisi': 'Тбилиси (GMT+4)',
      'Asia/Yerevan': 'Ереван (GMT+4)',
      'Asia/Bishkek': 'Бишкек (GMT+6)',
      'Asia/Tashkent': 'Ташкент (GMT+5)',
      'Asia/Ashgabat': 'Ашхабад (GMT+5)',
      'Europe/Minsk': 'Минск (GMT+3)',
      'Asia/Dushanbe': 'Душанбе (GMT+5)',
      'Europe/Kiev': 'Киев (GMT+3)',
      'Europe/Chisinau': 'Кишинёв (GMT+3)',
    };
    return {
      form: {
        timezone: '',
        cellInterval: 15
      },
      timezoneLabels,
      timezones: Object.keys(timezoneLabels)
    }
  },
  computed:{
    ...mapState('settings', ['setting'])
  },
  methods:{
    ...mapActions('settings', ['getSettings', 'updateSettings']),
    async saveTimezone() {
      await this.updateSettings({
        timezone: this.form.timezone,
        cellInterval: this.form.cellInterval
      })
      this.$message.success('Настройки сохранены')
    }
  },
  mounted() {
    this.getSettings().then(() => {
      const tz = this.setting.timezone
      this.form.timezone = this.timezones.includes(tz) ? tz : 'Europe/Moscow'
      this.form.cellInterval = this.setting.cellInterval || 15
    })
  }
}
</script>
<style scoped>

</style>
